import './modules/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

Alpine.plugin(persist);

//window.Alpine = Alpine;
import './modules/header';

async function loadAlpineRelatedModulesAndStartAlpine(){
  // These modules must be loaded before Alpine can be started

  if(document.querySelector('.material-browse-and-search')){
    await import('./modules/material-browse-and-search');
  }

  if(document.querySelector('.material-download-list')){
    await import('./modules/material-download-list');
  }

  Alpine.start();
}

loadAlpineRelatedModulesAndStartAlpine();

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();
